class FormHandler {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-form',
            fieldAttr: 'data-form-field'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$form = $element;
        this.initialize();
    }

    initialize () {
        this.initFormFields();
    }

    initFormFields () {
        const $$formFields = this.$form.querySelectorAll('[' + this.settings.fieldAttr + ']');

        if ($$formFields.length > 0) {
            import('./form-field').then(({ FormField }) => {
                for (let i = 0; i < $$formFields.length; i++) {
                    const $formField = $$formFields[i];
                    const formFieldAPI = new FormField($formField);
                    $formField.API = formFieldAPI;
                }
            });
        }
    }
}

export { FormHandler };
